import { atom } from "jotai";

export const visibleDrawerCampoAtom = atom(false);
export const camposAtom = atom ([]);
export const cargosAtom = atom ([]);